module.exports = __webpack_public_path__ + "static/media/rock-climbing.35228a2f.jpg";